import { MenuItem, TextField } from '@mui/material'
import { useFormikContext } from 'formik'

import {
  ECampaignTemplateFormKeys,
  TCreateCampaignTemplateForm,
  TCreateTemplateFromCampaignForm,
} from '~/features/admin/models'

export type TProps = {
  isLoading?: boolean
}

export default function CampaignTemplateVisibility({
  isLoading = false,
}: TProps) {
  const formik = useFormikContext<
    TCreateCampaignTemplateForm | TCreateTemplateFromCampaignForm
  >()
  const { values, errors, handleChange } = formik
  return (
    <TextField
      required
      select
      fullWidth
      size="small"
      label="Visibility"
      name={ECampaignTemplateFormKeys.visibility}
      value={values[ECampaignTemplateFormKeys.visibility] as string}
      error={Boolean(errors[ECampaignTemplateFormKeys.visibility])}
      helperText={errors[ECampaignTemplateFormKeys.visibility]}
      onChange={handleChange}
      disabled={isLoading}
    >
      <MenuItem value="global">Global</MenuItem>
    </TextField>
  )
}
